import { useDroppable } from '@dnd-kit/core';
import { DroppableSharedProps } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/Securities/SecurityRanking/securityRankingTypes.ts';

export const DroppableRankingContent = ({
	id,
	children,
	isOver,
	className,
}: DroppableSharedProps) => {
	const { setNodeRef } = useDroppable({
		id,
	});

	return (
		<div
			ref={setNodeRef}
			className={className}
			style={{
				backgroundColor: isOver ? 'rgba(0, 123, 255, 0.05)' : 'transparent',
				transition: 'background-color 0.2s',
			}}
		>
			{children}
		</div>
	);
};
